import styled from '@emotion/styled';
import { TAsset } from '@types';
import classNames from 'classnames';

type Props = {
  asset: TAsset;
  onClick: () => void;
  selected: boolean;
  size?: string;
};

const StyledAsset = styled.div<{ size }>`
  height: ${({ size }) => size || '64px'};
  width: ${({ size }) => size || '64px'};
`;

const Asset = ({ asset, onClick, selected, size = '64px' }: Props) => {
  return (
    <StyledAsset
      onClick={onClick}
      size={size}
      className={classNames(
        'tw:inline-flex tw:cursor-pointer tw:items-center tw:justify-center tw:rounded-lg tw:border-2 tw:bg-white tw:p-1 tw:transition tw:duration-300',
        {
          'tw:border-neutrals-light-grey tw:hover:border-neutrals-medium-grey': !selected,
          'tw:border-primary': selected,
        }
      )}>
      <img src={asset.fileUrl} alt={asset.assetName} className='tw:max-h-full tw:max-w-full' />
    </StyledAsset>
  );
};

export default Asset;
